import { useTranslation } from 'react-i18next'

import { TreatmentSpent } from 'app/audiences/types'
import { PagedTable } from 'app/common/presentation'

import { Modal, ModalProps } from 'components'

import styles from './Overview.module.scss'
import SpentsTable from './SpentsTable'

interface SpentsModalProps extends Pick<ModalProps, 'onClose' | 'open'> {
  treatmentSpents: TreatmentSpent[]
}

const pageSize = 6

const SpentsModal = ({ treatmentSpents, ...modalProps }: SpentsModalProps) => {
  const { t } = useTranslation('audiences')

  return (
    <Modal className={styles.modal} title={t('details.overview.spents.title')} {...modalProps}>
      <div>{t('details.overview.spents.description')}</div>
      <SpentsTable
        className={styles.table}
        data={treatmentSpents}
        pageSize={pageSize}
        TableComponent={PagedTable}
      />
    </Modal>
  )
}

export default SpentsModal
